// API Configuration - DYNAMIC detection
// Running on localhost? -> http://localhost:8000
// Running on deployed domain? -> https://whisk-api.loafstack.dev

const isLocalhost = window.location.hostname === 'localhost' || 
                    window.location.hostname === '127.0.0.1';

export const API_BASE = process.env.REACT_APP_API_BASE || "http://localhost:8000";

